var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.example.caption)?_c('div',{staticClass:"clpp-api-example-caption"},[_vm._v(_vm._s(_vm.example.caption))]):_vm._e(),_c('div',{staticClass:"clpp-api-example-code"},[_c('pre',[_c('code',{staticClass:"language-javascript",domProps:{"innerHTML":_vm._s(_vm.code)}},[_vm._v(_vm._s(_vm.code))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }